import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=6e3a3a6a&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=6e3a3a6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a3a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e3a3a6a')) {
      api.createRecord('6e3a3a6a', component.options)
    } else {
      api.reload('6e3a3a6a', component.options)
    }
    module.hot.accept("./Gallery.vue?vue&type=template&id=6e3a3a6a&scoped=true", function () {
      api.rerender('6e3a3a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Gallery/Gallery.vue"
export default component.exports